import { ApiEnvelopeLike } from './tryParseApiEnvelopeFromBlob';

export function getEnvelopeMessage(env: ApiEnvelopeLike | null): string | null {
  const msg = env?.error?.message;
  return typeof msg === 'string' && msg.trim() ? msg : null;
}
